import { Component, OnInit, ViewChild, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { FieldDataService } from "src/app/services/fieldData/field-data.service";
import { MatDialog } from "@angular/material/dialog";
import { NodeAlarmComponent } from "../node-alarm/node-alarm.component";
import { cloneDeep } from "lodash";

@Component({
  selector: "app-entradas-nav",
  templateUrl: "./entradas-nav.component.html",
  styleUrls: ["./entradas-nav.component.scss"],
})
export class EntradasNavComponent implements OnInit, OnDestroy {
  // Para la renavegación del componente
  mySubscription: any;
  uuid: string;

  // Para la información de la navegación actual
  nombreActual: string;
  dispositivoActual: string;

  // para las entradas
  entradas: any;
  displayedColumns: string[] = [
    "topic",
    "descripcion",
    "last",
    "lastFecha",
    "lastValor",
    "unidad",
  ];
  dataSource: MatTableDataSource<any>;
  // @ViewChild('TableEntradasPaginator', { static: true }) tableEntradasPaginator: MatPaginator;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  loading: boolean = true;
  totalAlarms: number;
  sub: any;
  dataArray: any;
  arreglo: any;
  alarmsCount: number;
  silenciadosCount: number;

  // Para el momento actual:
  timeStamp = Date.now() * 1000000;
  limiteAlerta: any; // Establecemos el limite superiorpara la alerta a 1 hora
  // [(60*60) * 1000000000] para conseguirlo en nanosegundos

  isMBDevice: boolean = false;
  registers: any[] = [];
  mqttTopicsRT: any[];
  configRT: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dataService: FieldDataService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.mqttTopicsRT = [];
    this.configRT = {
      layout: {
        width: "175px",
        height: "350px",
        margin: {
          l: 50,
          r: 70,
          b: 75,
          t: 0,
          pad: 4,
        },
      },
      config: {
        displayModeBar: false,
        responsive: true,
      },
    };
    // Renavegamos
    this.renavigate();
    // Obtenemos los datos
  }

  // Funcion para poder 'renavegar' por el mismo componente:
  renavigate() {
    // Con las dos suscripciones de debajo, hacemos creer a angular que no hemos visitado el componente
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Para hacer creer a angular que no hemos estado en el componente
        this.router.navigated = false;
      }
    });
    // Nos suscribimos al parametro de uuid del link para saber a que dispositivo tenemos que navegar
    // a continuacion.
    this.activatedRoute.params.subscribe((params) => {
      this.uuid = params.uuid;
      this.getData();
    });
  }

  getData() {
    // Obtenemos la información de la entrada actual
    this.arreglo = [];
    this.alarmsCount = 0;
    this.silenciadosCount = 0;
    this.sub = this.dataService
      .getEntradas(this.uuid)
      .subscribe(({ data, loading }) => {
        this.entradas = data.findSource;
        this.isMBDevice = this.entradas.labels.includes("MbDevice");
        if (this.entradas !== undefined) {
          if (this.entradas.MbDevice && this.entradas.MbDevice[0].MbRegister) {
            this.registers = this.entradas.MbDevice[0].MbRegister;
          }
        }
        this.nombreActual = this.entradas.nombre;
        this.dispositivoActual =
          this.entradas.entradasConnection.edges[0].node.tieneConnection.edges[0].node.nombre;
        this.dataSource = new MatTableDataSource(
          this.entradas.entradasConnection.edges
        );
        this.dataArray = this.entradas.entradasConnection.edges.filter(
          (elem) => elem.last != null && elem.lastFecha != null
        );
        for (let i = 0; i < this.dataArray.length; i++) {
          this.arreglo[i] = {
            indice: i,
            data: this.dataArray[i],
          };
          this.dataService
            .getNodeAlarms(this.dataArray[i].uuid)
            .subscribe((data) => {
              if (data.some((elem) => elem.alarmado && !elem.silenciado)) {
                this.arreglo[i].alarmadosCount = data.filter(
                  (elem) => elem.alarmado
                ).length;
                this.alarmsCount++;
              } else if (data.some((elem) => elem.silenciado)) {
                this.arreglo[i].silenciadosCount = data.filter(
                  (elem) => elem.alarmado
                ).length;
                this.silenciadosCount++;
              }
            });
        }
        this.dataSource = new MatTableDataSource(
          this.arreglo.filter((elem) => elem.data.lastFecha)
        );
        this.dataSource.paginator = this.paginator;
        this.loading = loading;
      });

    // Cargamos la config desde el servicio de estructura de campo
    this.dataService
      .getConfigFieldData()
      .subscribe((data) => (this.limiteAlerta = data.limiteAlarma));
  }

  // Para volver al estado anterior de la navegacion
  previousState() {
    window.history.back();
  }

  // Para filtrar la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  // Para el filtro anidado
  nestedFilterCheck(search, data, key) {
    if (typeof data[key] === "object") {
      for (const k in data[key]) {
        if (data[key][k] !== null) {
          search = this.nestedFilterCheck(search, data[key], k);
        }
      }
    } else {
      search += data[key];
    }
    return search;
  }

  openAlertsComponent(filterMode: string) {
    const dialogRef = this.dialog.open(NodeAlarmComponent, {
      data: {
        uuid: this.uuid,
        componentMode: "entrada",
        nodeType: "source",
        title: "Nodos con datos en estado:",
        filterMode: filterMode,
      },
      height: "75%",
      width: "85%",
      minWidth: 270,
    });
    dialogRef.afterClosed().subscribe((data) => {
      this.getData();
    });
  }

  onKey(value) {
    this.registers = this.search(value);
  }

  search(value: string) {
    let filter = value.toLowerCase();
    return this.registers.filter((option) =>
      option.descripcion.toLowerCase().includes(filter)
    );
  }

  createRT(value) {
    value = cloneDeep(value);
    value.map(
      (r) =>
        (r["mqtt"] = {
          publishTopic: "LYNX-FIELD/RT/" + this.uuid + "/" + r.uuid,
          subscribeTopic: "RT/" + this.uuid + "/" + r.uuid + "/AM/1",
          payload: "true",
        })
    );
    this.mqttTopicsRT = Object.assign(value, {});
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    // this.subCountEntradasAlarmadas.unsubscribe();
  }

  //TODO: Revisar -> Método no implementado
  rearmaAlarmaNodo() {}
}
